import { render } from "./AudioTemplatePanel.vue?vue&type=template&id=e2053f84&scoped=true"
import script from "./AudioTemplatePanel.vue?vue&type=script&lang=js"
export * from "./AudioTemplatePanel.vue?vue&type=script&lang=js"

import "./AudioTemplatePanel.vue?vue&type=style&index=0&id=e2053f84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2053f84"]])

export default __exports__